export default __webpack_public_path__ + "static/media/KnowledgeBase.edb53e37.svg";